module.exports = __webpack_public_path__ + "static/5-f466af893bea7706955d43b12d750bfa.png";